var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighlightHandshake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.74 7.86h-5.16c-.11 0-.21-.03-.3-.1L20.39 5.7c-.18-.13-.39-.2-.61-.2H16.4l-4.49 5.31c-.58.65-.8 1.57-.59 2.44.23.75.81 1.32 1.53 1.51.72.19 1.47-.04 2-.59l3.94-4.24a.55.55 0 01.42-.17c.16.01.3.09.4.22l2.92 3.87c1.03 1.37.96 3.34-.15 4.62l-.03.04h6.38l.01-.02V7.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.79 11.35l-3.44 3.76c-1.26 1.31-3.23 1.31-4.49 0-1.2-1.31-1.25-3.42-.11-4.79L12.68 8H9.12c-.32 0-.63.1-.9.3l-3.77 1.96c-.09.06-.19.1-.3.1H1.26l-.01.02v9.4l.01.02h6.05c.13 0 .25.05.35.14.15.14.35.34.59.59 1.26 1.38 2.68 2.58 4.23 3.56 1.53.81 3.36.44 4.52-.91l4.16-5.38c.74-.85.79-2.17.11-3.09l-2.48-3.36z"
  })));
}

export default SvgHighlightHandshake;